import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from "./index.module.scss"
import cn from "classnames";
import Badge from "../../shared/Badge";
import { File } from '../../../services';
import { requestErrorDisplay } from '../../../utils';
import DotsIcon from '../../shared/icons/DotsIcon';
import EditIcon from '../../shared/icons/EditIcon';
import { Link } from 'react-router-dom';


const WorkersItemCard = ({ isHead, item }) => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);

    // Define translated data structures inside the component instance
    const EMPLOYEE_ROLES_DATA = {
        "Employee": { title: t('workersItemCard.roles.employee'), role: 'Employee' },
        "Admin": { title: t('workersItemCard.roles.admin'), role: 'Admin' },
    }

    const EMPLOYEE_STATUSES_DATA = {
        "Confirmed": { title: t('workersItemCard.statuses.confirmed'), color: 'green' },
        "UnActive": { title: t('workersItemCard.statuses.unActive'), color: 'gray' },
        "Draft": { title: t('workersItemCard.statuses.draft'), color: 'blue' },
        "Moderation": { title: t('workersItemCard.statuses.moderation'), color: 'blue' },
        "Rejected": { title: t('workersItemCard.statuses.rejected'), color: 'blue' },
        "Pending": { title: t('workersItemCard.statuses.pending'), color: 'blue' },
    }

    console.log("item", item);

    return (
      <div className={cn(style.wrapper, { [style.isHead]: isHead })}>
          {isHead && (
            <>
                <div className={style.item}>
                    {t('workersItemCard.table.header.name')}
                </div>
                <div className={style.item}>
                    {t('workersItemCard.table.header.lastName')}
                </div>
                <div className={style.item}>
                    {t('workersItemCard.table.header.phone')}
                </div>
                <div className={style.item}>
                    {t('workersItemCard.table.header.email')}
                </div>
                <div className={style.item}>
                    {t('workersItemCard.table.header.role')}
                </div>
                <div className={cn(style.item, style.item_status)} style={{ paddingRight: "75px" }}>
                    {t('workersItemCard.table.header.status')}
                </div>
            </>
          )}
          {!isHead && (
            <>
                <div className={style.item} data-label={t('workersItemCard.table.header.name')}>
                    <p>{item.name}</p>
                </div>
                <div className={style.item} data-label={t('workersItemCard.table.header.lastName')}>
                    <p>{item.surname}</p>
                </div>
                <div className={style.item} data-label={t('workersItemCard.table.header.phone')}>
                    <p>{item.phoneNumber}</p>
                </div>
                <div className={style.item} data-label={t('workersItemCard.table.header.email')}>
                    <p>{item.email}</p>
                </div>
                <div className={style.item} data-label={t('workersItemCard.table.header.role')}>
                    <p>{EMPLOYEE_ROLES_DATA[item.role]?.title}</p>
                </div>
                <div className={cn(style.item, style.item_status)} data-label={t('workersItemCard.table.header.status')}>
                    <Badge
                      type={`${EMPLOYEE_STATUSES_DATA[item.state]?.color || 'default'}`}
                      text={EMPLOYEE_STATUSES_DATA[item.state]?.title}
                    />
                    <Link to={`/workers/edit/${item.id}`} className={style.button}>
                        <EditIcon />
                    </Link>
                </div>
            </>
          )}
      </div>
    );
};

export default WorkersItemCard;